module.exports = __webpack_public_path__ + "static/media/Paw4_Outline_1c.06088cf3.svg";